import { Outlet } from "react-router-dom";

export default function LayoutGuest() {
  return (
    <div className="min-h-screen w-full bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 flex items-center justify-center p-4">
      <Outlet />
    </div>
  );
}
